import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import BlogList from "./tabItems/BlogList";
import AddBlog from "./tabItems/AddBlog";
import { setBlog } from "../../store/slices/blogSlice";

export const blogTabConfig = {
    LIST: "1",
    ADD: "2"
}

const BlogTab = () => {
    const [currentTab, setCurrentTab] = useState(blogTabConfig.LIST);
    const [tabTada, setTabData] = useState({});
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(setBlog({}));
    }, [])

    const onSwitchTab = (key, data) => {
        setCurrentTab(key);
    } 

    const tabs = [
        {
          key: blogTabConfig.LIST,
          label: 'Blogs',
          children: <BlogList onSwitchTab={onSwitchTab} />,
        },
        {
            key: blogTabConfig.ADD,
            label: 'Add / Modify Blog',
            children: <AddBlog onSwitchTab={onSwitchTab} tabProps={{}} />,
        }
    ];

    const onChange = (key) => {
        if (key !== blogTabConfig.ADD) {
            dispatch(setBlog({}));
            window.location.reload();
        } else {
            setCurrentTab(key);
        }
    };

    return (
        <div>
            <div className="text-2xl pb-3">Blogs</div>
            <div className="px-4 border pb-6 bg-white pop-left">
                <Tabs defaultActiveKey="1" activeKey={currentTab} items={tabs} onChange={onChange} />
            </div>
        </div>
    )
}

export default BlogTab;